<template lang="pug">
  #section4
    #s4s1.group
      .background.block
        .title.text-center
          h2.py-0.uppercase.light ¿Cómo entra y evoluciona el 
            span.accent-orange-text.bolder SARS-CoV-2 en el cuerpo humano? 
        .capside
          img(src="/assets/img/chapter1/respiratorio.png")
      #s4s1t1.block
        .fake-header
        .slide
          p La manera principal de contagio del virus es por medio de gotas provenientes de la tos, aliento o estornudos de una persona infectada. Una vez que el SARS-CoV-2 entra al cuerpo, este viaja bajando por medio de nuestro aparato respiratorio. 
        .fake-footer

      #s4s1t2.block
        .fake-header
        .slide
          p Nuestro sistema respiratorio inferior contiene más receptores (donde el virus embona) por lo que SARS-CoV-2 suele llegar más abajo que los coronavirus causantes de los resfríos comunes. Al infectar la célula, el virus se replica múltiples veces hasta provocar que la célula se autodestruya, liberando nuevos virus que infectarán a nuevas células. 
        .fake-footer
</template>

<script>
export default {
  name: "Section4"
};
</script>
<style lang="scss" scoped>
#section4 {
  margin-top: 80vh;
  min-height: 400vh;
  #s4s1 {
    height: 400vh;
    .block {
      @include blockin(100%, 100%, 0, 0%);
      .title {
        position: sticky;
        top: 15%;
        left: 5%;
        width: 90%;
        min-width: 250px;
        max-width: 700px;
        margin-bottom: 64%;
      }
      .capside {
        position: sticky;
        top: 66%;
        img {
          width: 65%;
          max-width: 333px;
          min-width: 100px;
          margin: 0px -10px;
        }
      }
      .slide {
        //height: 50%;
        h2,
        p {
          margin-top: 5rem;
          @include blockinP(90%, 29%, 5%);
          min-width: 250px;
          max-width: 700px;
          text-align: center;
        }
      }
    }
    #s4s1t1 {
      @include blockin(100%, 50%, 0%, 0%);
      .fake-header {
        @include fakinH(2vh, 0%);
      }
      .fake-footer {
        @include fakinF(3vh, 0%);
      }
    }
    #s4s1t2 {
      @include blockin(100%, 50%, 50%, 0%);
      .fake-header {
        @include fakinH(2vh, -3%);
      }
      .fake-footer {
        @include fakinF(3vh, 3%);
      }
    }
    svg {
      position: sticky;
      margin-left: -30%;
      top: 69%;
      z-index: -1;
    }
  }
}

@media (min-width: 768px) and (max-width: 991px) {
  #section4 {
    #s4s1 {
      .block {
        .capside {
          top: 55%;
          width: 70%;
          left: 10%;
          img {
            width: 100%;
            max-width: 733px;
            min-width: 100px;
          }
        }
      }
    }
  }
}

@media (min-width: 992px) and (max-width: 1399px) {
  #section4 {
    #s4s1 {
      .block {
        .title {
          margin-bottom: 34%;
          max-width: 700px;
          width: 40%;
        }
        .capside {
          top: 26%;
          left: 50%;
          width: 50%;
          img {
            width: 100%;
            max-width: 750px;
            min-width: 100px;
          }
        }
        .slide {
          h2,
          p {
            @include blockinP(40%, 36%, 5%);
            max-width: 700px;
          }
        }
      }
      #s4s1t4 {
        .fake-footer {
          @include fakinF(3vh, 9%);
        }
      }
    }
  }
}

@media (min-width: 1400px) {
  #section4 {
    #s4s1 {
      .block {
        .title {
          margin-bottom: 34%;
        }
        .capside {
          top: 26%;
          left: 50%;
          width: 50%;
          img {
            width: 100%;
            max-width: 750px;
            min-width: 100px;
          }
        }
        .slide {
          h2,
          p {
            @include blockinP(45%, 36%, 5%);
            max-width: 700px;
          }
        }
      }
      #s4s1t4 {
        .fake-footer {
          @include fakinF(3vh, 9%);
        }
      }
    }
  }
}
</style>
